import React, { Component } from 'react';

import strings from '../../../assets/localization';
import Modal from '../../UI/Modal/Modal';
import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';
import InputError from '../../UI/InputError/InputError';
import Spinner from '../../UI/Spinner/Spinner';
import AlertError from '../AlertError/AlertError';
import AppleLoginContainer from '../../../containers/Auth/AppleLogin/AppleLoginContainer';
import NavbarElement from '../../Navigation/Navbar/NavbarElement/NavbarElement';
import UrlLink from '../../UI/UrlLink/UrlLink';
import classes from './LoginModal.module.css';
import paths from '../../../constants/paths';
import config from '../../../constants/config';
import avatar from '../../../assets/images/avatar/user-placeholder-gender-one.webp';
import ModalScroll from '../../UI/ModalScroll/ModalScroll';

class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.textEmailInput = React.createRef();
    this.textPasswordInput = React.createRef();
    this.state = {
      isEmailEmpty: true,
      isPasswordEmpty: true,
      email: '',
      password: '',
      emailTouched: false,
      passwordTouched: false,
    };
  }

  componentDidMount() {
    if (this.state.email === '') {
      this.textEmailInput.focus();
    }
  }

  onEmailChange = (e) => {
    const {
      target: { value },
    } = e;
    this.setState({
      email: value,
      isEmailEmpty: value.length === 0,
    });
  };

  onPasswordChange = (e) => {
    const {
      target: { value },
    } = e;
    this.setState({
      password: value,
      isPasswordEmpty: value.length === 0,
    });
  };

  renderEmailError = () => {
    const { isEmailEmpty, emailTouched } = this.state;
    return (
      <InputError
        style={{
          display:
            (emailTouched && isEmailEmpty) ||
            (!isEmailEmpty && !this.validateEmail())
              ? 'block'
              : 'none',
        }}
      >
        {strings.emailError}
      </InputError>
    );
  };

  renderPasswordError = () => {
    const { isPasswordEmpty, passwordTouched } = this.state;
    return (
      <InputError
        style={{
          display:
            (passwordTouched && isPasswordEmpty) ||
            (!isPasswordEmpty && !this.validatePassword())
              ? 'block'
              : 'none',
        }}
      >
        {isPasswordEmpty ? strings.enterYourPassword : strings.useMinChar}
      </InputError>
    );
  };

  validateEmail = () => {
    return config.EMAIL_REGEX.test(this.state.email);
  };

  validatePassword = () => {
    return this.state.password.length >= 6;
  };

  validateEmailAndPassword = () => {
    return this.validateEmail() && this.validatePassword();
  };

  toggleAlertError = (errorMessage) => {
    this.setState({ showAlert: !this.state.showAlert, errorMessage });
  };

  onEmailKeyPress = (e) => {
    if (e.charCode === 13) {
      this.textPasswordInput.focus();
    }
  };

  onPasswordKeyPress = (e) => {
    if (e.charCode === 13 && this.validateEmailAndPassword()) {
      this.login();
    }
  };

  onEmailBlur = () => {
    this.setState({ emailTouched: true });
  };

  onPasswordBlur = () => {
    this.setState({ passwordTouched: true });
  };

  login = () => {
    this.props.emailLogin(this.state.email, this.state.password);
  };

  renderSpinner = () => {
    return (
      <div className={classes.SpinnerWrapper}>
        <Spinner size='Tiny' />
      </div>
    );
  };

  renderReactivateAccount = () => {
    return (
      <div className={classes.ReactivateAccount}>
        <div className={classes.TitleWrapper}>
          <div className={classes.Title}>{strings.welcomeBack}!</div>
          <p className={classes.Text}>{strings.prevYouDeactivYourAcc}.</p>
          <p className={classes.Text}>
            <b>{strings.doUwantToReacYourAcc}?</b>
          </p>
        </div>
        <div className={classes.ImageWrapper}>
          <img className={classes.Img} src={avatar} alt='avatar' />
        </div>
        <div className={classes.ButtonWrapper}>
          <Button
            style={{ marginBottom: '1rem' }}
            clicked={() => {
              this.props.emailLogin(this.state.email, this.state.password, 1);
            }}
          >
            {strings.yesReactivateMyAcc}
          </Button>
          <Button btnType='Secondary' clicked={this.props.goBack}>
            {strings.noKeepDeactivated}
          </Button>
        </div>
      </div>
    );
  };

  renderReactivateAccountModal = () => {
    if (!this.props.isLandscape) {
      return (
        <ModalScroll navbarCenterElement={strings.reactivateAccount}>
          {this.renderReactivateAccount()}
        </ModalScroll>
      );
    } else {
      return (
        <Modal navbarCenterElement={strings.reactivateAccount}>
          {this.renderReactivateAccount()}
        </Modal>
      );
    }
  };

  render() {
    return this.props.showReactivateModal ? (
      this.renderReactivateAccountModal()
    ) : (
      <Modal
        navbarLeftElement={
          <NavbarElement
            fill='var(--svg-color-navigation-light)'
            imgIcon='/sprites.svg#icon-close-small'
            alt='Close'
            clicked={this.props.goBack}
          />
        }
        navbarCenterElement={strings.LogIn}
      >
        <div className={classes.Login}>
          <Input
            setRef={(c) => (this.textEmailInput = c)}
            type='email'
            inputMode='email'
            autoCapitalize='off'
            autoCorrect='off'
            autoComplete='email'
            value={this.state.email}
            onFocus={this.props.onFocus}
            onChange={this.onEmailChange}
            onBlur={this.onEmailBlur}
            label={`${strings.EmailAddress}:`}
            onKeyPress={this.onEmailKeyPress}
            placeholder={strings.EnterEmailAddress}
            maxLength={128}
            showRedTriangle={
              (this.state.emailTouched && this.state.isEmailEmpty) ||
              (!this.state.isEmailEmpty && !this.validateEmail())
            }
          />
          {this.renderEmailError()}
          <Input
            setRef={(c) => (this.textPasswordInput = c)}
            type='password'
            label={`${strings.password}:`}
            onChange={this.onPasswordChange}
            onBlur={this.onPasswordBlur}
            placeholder={strings.EnterPassword}
            onKeyPress={this.onPasswordKeyPress}
            value={this.state.password}
            maxLength={128}
            showRedTriangle={
              (this.state.passwordTouched && this.state.isPasswordEmpty) ||
              (!this.state.isPasswordEmpty && !this.validatePassword())
            }
          />
          {this.renderPasswordError()}
          <UrlLink style={{ textAlign: 'right' }} to={paths.FORGOT_PASSWORD}>
            {strings.ForgotYourPassword}
          </UrlLink>
        </div>
        <div className={classes.FooterWrapper}>
          <div className={classes.Footer}>
            <Button
              disabled={!this.validateEmailAndPassword()}
              clicked={this.login}
            >
              {strings.LogIn}
            </Button>
            <AppleLoginContainer style={{ marginTop: '1rem' }}>
              {strings.logInWithApple}
            </AppleLoginContainer>
          </div>
          {this.props.showSpinner ? this.renderSpinner() : null}
        </div>
        {this.props.showErrorAlert ? (
          <AlertError
            dismissAlert={this.props.dismissAlert}
            errorMessage={this.props.errorAlertMessage}
          />
        ) : null}
      </Modal>
    );
  }
}

export default LoginModal;



// WEBPACK FOOTER //
// ./src/components/Auth/LoginModal/LoginModal.js